import { render, staticRenderFns } from "./organizationalIndicators.vue?vue&type=template&id=0ebe024c&scoped=true&"
import script from "./organizationalIndicators.vue?vue&type=script&lang=js&"
export * from "./organizationalIndicators.vue?vue&type=script&lang=js&"
import style0 from "./organizationalIndicators.vue?vue&type=style&index=0&id=0ebe024c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebe024c",
  null
  
)

export default component.exports